export const lightTheme = {
  nav: '#9fb1c9',
  body: '#abb9cc',
  secondary: '#d0d5db',

  text: '#000000',
};

export const darkTheme = {
  nav: '#04101f',
  body: '#101b29',
  secondary: '#232c38',

  text: '#ffffff',
};